// extracted by mini-css-extract-plugin
export default {"contactDetails":"styles_contactDetails__0nPoQ","formItem":"styles_formItem__PeZ0v"};